import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

// Row layout: TextColumn and IllustrationContainer are direct siblings here, so the
// illustration (default stretch alignment) spans the container's full height — level
// with the title at the top, not just the bullets/button below it. No padding here (it
// lives on TextColumn instead) and overflow: hidden so the illustration's flush top/bottom
// edges get clipped to the container's own rounded corners rather than poking past them.
export const DemoBannerContainer = styled.div`
  display: flex;
  gap: ${Spacing.S12};
  justify-content: space-between;
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.Green100};
  overflow: hidden;
`

export const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${Spacing.S12} 0 ${Spacing.S12} ${Spacing.S24};
`

export const BulletList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`

export const BulletItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${Spacing.S12};
  margin-bottom: ${Spacing.S4};
`

export const IconBadge = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: ${BorderRadius.RFull};
  background-color: ${transparentize(0.5, Color.Green200)};
`

// max-height caps this at less than the illustration's own native size (256px) — without
// it, `svg { height: 100% }` can't resolve against this stretch-driven parent and falls
// back to that native size, which becomes the tallest thing in the row and overrides
// however short TextColumn's own content is trying to make the banner.
export const IllustrationContainer = styled.div`
  flex-shrink: 0;
  max-height: 220px;
  margin-left: auto;

  svg {
    width: auto;
    height: 100%;
  }
`
